<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="CARGUES DINÁMICOS DISPONIBLES" key="1">
        <g-datatable :columns="loadsTable.columns"
                     :endpoint="loadsTable.endpoint"
                     :tableConfig="loadsTable.tableConfig"
                     :actions="loadsTable.actions"
                     @action="loadsTableDtAction"
        ></g-datatable>
      </a-tab-pane>
    </a-tabs>

    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Historial de Ejecuciones" key="1">
        <g-datatable :columns="execsTable.columns"
                     :endpoint="execsTable.endpoint"
                     :tableConfig="execsTable.tableConfig"
                     :actions="execsTable.actions"
                     @action="execsTableDtAction"
        ></g-datatable>
      </a-tab-pane>
    </a-tabs>

    <dynamic-load-run-modal ref="runModal" @success="showExecutionModal"></dynamic-load-run-modal>
    <dynamic-load-status-modal ref="statusModal"></dynamic-load-status-modal>

  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        cargueSeleccionado: {},
        execSeleccionado: {},
        loading: false,
        loadsTable: {
          endpoint: 'dynamic_loads_active',
          columns: [
            {title: '#', dataIndex: 'id', sorter: true},
            {title: 'Nombre', dataIndex: 'name', sorter: true},
            {title: 'Descripción', dataIndex: 'description', sorter: true}
          ],
          actions: {
            title: 'Acciones',
            key: 'acciones',
            width: 90,
            fixed: 'right',
            scopedSlots: {customRender: 'hooverableAction'},
            actions: [
              {
                name: 'ejecutar',
                text: 'Cargar Archivo',
                props: {size: 'small', type: 'link', icon: 'code', style: 'color:green;'}
              }
            ]
          },
          tableConfig: {
            rowKey: 'id'
          }
        },
        execsTable: {
          endpoint: 'dynamic_load_exec',
          columns: [
            {title: '#', dataIndex: 'id', sorter: true},
            {title: 'Descripción', dataIndex: 'description', sorter: true},
            {title: 'Estado', dataIndex: 'exec_status', sorter: true},
            {title: 'Lineas Procesadas', dataIndex: 'lineas_procesadas', sorter: true}
          ],
          actions: {
            title: 'Acciones',
            key: 'acciones',
            width: 90,
            fixed: 'right',
            scopedSlots: {customRender: 'hooverableAction'},
            actions: [
              {
                name: 'detalles',
                text: 'Detalles',
                props: {size: 'small', type: 'link', icon: 'info-circle', style: 'color:green;'}
              }
            ]
          },
          tableConfig: {
            rowKey: 'id'
          }
        }
      }
    },
    methods: {
      loadsTableDtAction (action) {
        switch (action.action) {
          case 'ejecutar':
            this.cargueSeleccionado = action.record
            this.$refs.runModal.showModal('Nuevo', this.cargueSeleccionado)
            break
        }
      },
      execsTableDtAction (action) {
        switch (action.action) {
          case 'detalles':
            this.execSeleccionado = action.record
            this.$refs.statusModal.showModal(this.execSeleccionado.id)
            break
        }
      },
      showExecutionModal (exeuctionId) {
        this.$refs.runModal.closeModal()
        this.$refs.statusModal.showModal(exeuctionId)
      }
    },
    computed: {
      showDetails () {
        return !JsUtils.isEmpty(this.cargueSeleccionado)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/DynamicLoads/DynamicLoad.vue